export default __webpack_public_path__ + "static/media/Consistent-_-Predictable.886f9551.jpg";